import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UIState {
  // Add any other UI-related state here in the future
  // For now, this store is mostly empty as modal functionality has been moved to local component state
}

export const useUIStore = create<UIState>()(
  devtools(
    (set, get) => ({
      // UI state will go here
    }),
    { name: 'ui-store' }
  )
);